<template>
  <div class="youtube">
    <iframe :src="url" title="" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"  allowFullScreen><br>Powered by <a href="https://youtubeembedcode.com">youtube embed code generator</a> and <a href="https://gamstopcancel.com/">can you cancel gamstop</a></iframe>
  </div>
</template>

<script>
export default {
  name: 'Youtube',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.youtube {
  display: flex;
  justify-content: center;
  align-items: center;
  iframe {
    width: 100%;
    height: auto;
    min-height: 60vh;
  }
}
</style>
